import { render } from "./MypageMonthlyFoodsRankingDetailPage.vue?vue&type=template&id=af3a51c0&scoped=true&ts=true"
import script from "./MypageMonthlyFoodsRankingDetailPage.vue?vue&type=script&lang=ts"
export * from "./MypageMonthlyFoodsRankingDetailPage.vue?vue&type=script&lang=ts"

import "./MypageMonthlyFoodsRankingDetailPage.vue?vue&type=style&index=0&id=af3a51c0&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3a51c0"]])

export default __exports__